import { render, staticRenderFns } from "./have-a-voucher.vue?vue&type=template&id=6bf1c76f&"
import script from "./have-a-voucher.vue?vue&type=script&lang=js&"
export * from "./have-a-voucher.vue?vue&type=script&lang=js&"
import style0 from "./have-a-voucher.vue?vue&type=style&index=0&id=6bf1c76f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports